export default __webpack_public_path__ + "56fb38ac134ab202027c3458a2d8c5c5.png";